import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=020f91c5&scoped=true"
import script from "./FaqList.vue?vue&type=script&lang=js"
export * from "./FaqList.vue?vue&type=script&lang=js"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=020f91c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f91c5",
  null
  
)

export default component.exports